import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionPut, serviceCall } from '../../serviceCall'

const updateMaintenancePlanStatusApi = (data, callback, errorCallBack, params) => {

    return async (dispatch) => {

        formDataCommonFunctionPut(data, apiConstants.HOME_MAINTENANCE.UPDATE_MAINTENANCE_PLAN_STATUS)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}

export default updateMaintenancePlanStatusApi;
